/**
 * The Customize seam (1.AB-2 deliverable 5): `ReferenceActionsProvider` carries the one action a
 * reference page may offer, an editable homebrew copy of a creature, a spell or an item. 1.Y
 * mounts it with 1.AC-2's handler; without a provider the page has no "Customize" button.
 */
import { createContext, type ReactNode, useContext } from 'react';

export interface CustomizeTarget {
  readonly docId: string;
  /** A creature's primary sheet; null for a spell or an item (2.M deliverable 22). */
  readonly sheetId: string | null;
  readonly title: string;
}

export interface ReferenceActions {
  readonly onCustomize?: ((target: CustomizeTarget) => void) | undefined;
}

const EMPTY: ReferenceActions = Object.freeze({});
const ActionsContext = createContext<ReferenceActions>(EMPTY);

export function ReferenceActionsProvider({
  onCustomize,
  children,
}: {
  readonly onCustomize?: ((target: CustomizeTarget) => void) | undefined;
  readonly children?: ReactNode;
}) {
  return <ActionsContext.Provider value={{ onCustomize }}>{children}</ActionsContext.Provider>;
}

/** An empty object outside a provider. */
export function useReferenceActions(): ReferenceActions {
  return useContext(ActionsContext);
}
